/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

import { ClientBusinessDefinedState, dashboard } from 'types';
import { convertClientObjectToServerObject } from 'utils/businessDefinedStateUtils';
import { safeEnumCompare } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { BusinessDefinedState, BusinessDefinedStateList, PartyState, TextingConfig } = protos;

export function fetchBusinessDefinedStatesByBusinessId(businessId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/business/${businessId}/service/config/state`,
      type: AppConstants.BUSINESS_DEFINED_STATE_LIST_FETCH,
    },
  };
}

export function fetchTextMessageConfigByBusinessId(businessId: number): ApiAction {
  return {
    TockApi: {
      getProto: `/business/${businessId}/service/config/texting`,
      type: AppConstants.TEXT_MESSAGING_CONFIG_FETCH,
    },
  };
}

export function upsertTextMessageConfig(
  businessId: number,
  textingConfig: dashboard.TextingConfig
): ApiAction {
  return {
    TockApi: {
      putProto: `/business/${businessId}/service/config/texting`,
      type: AppConstants.TEXT_MESSAGING_UPSERT,
      request: TextingConfig.fromObject(textingConfig),
      toast: 'Texting configuration updated',
    },
  };
}

export function insertBusinessDefinedState(
  businessId: number,
  primaryState: string,
  color: any
): ApiAction {
  const jsonForProto = {
    color,
    primaryState,
    canDelete: true,
  };
  return {
    TockApi: {
      postListProto: `/business/${businessId}/service/config/state`,
      type: AppConstants.BUSINESS_DEFINED_STATE_INSERT,
      request: BusinessDefinedState.fromObject(jsonForProto),
      context: { primaryState },
      toast: 'Party status created',
    },
  };
}

export function updateBusinessDefinedState(
  businessDefinedState: ClientBusinessDefinedState,
  businessId: number
): ApiAction {
  const request = BusinessDefinedState.fromObject(
    convertClientObjectToServerObject(businessDefinedState)
  );
  return {
    TockApi: {
      putListProto: `/business/${businessId}/service/config/state`,
      type: AppConstants.BUSINESS_DEFINED_STATE_UPDATE,
      request,
      context: { primaryState: businessDefinedState.primaryState },
      toast: 'Party status updated',
    },
  };
}

export function updateBusinessDefinedStateList(
  businessDefinedState: dashboard.BusinessDefinedState[],
  businessId: number,
  updatingState: dashboard.BusinessDefinedState
): ApiAction {
  const request = BusinessDefinedStateList.fromObject({
    businessDefinedState: _.map(businessDefinedState, (state) =>
      BusinessDefinedState.fromObject(state)
    ),
  });
  const primaryStateAreaUpdating = safeEnumCompare(
    updatingState.primaryState,
    PartyState,
    PartyState.SEATED
  )
    ? PartyState.SEATED
    : PartyState.EXPECTED;
  return {
    TockApi: {
      putListProto: `/business/${businessId}/service/config/state/list`,
      type: AppConstants.BUSINESS_DEFINED_STATE_UPDATE,
      request,
      context: primaryStateAreaUpdating,
      toast: 'Party status updated',
    },
  };
}

export function deleteBusinessDefinedState(
  businessDefinedState: any,
  businessId: number
): ApiAction {
  return {
    TockApi: {
      deleteListProto: `/business/${businessId}/service/config/state/${businessDefinedState.id}`,
      type: AppConstants.BUSINESS_DEFINED_STATE_DELETE,
      context: { primaryState: businessDefinedState.primaryState },
      toast: 'Party status deleted',
    },
  };
}
